const insertElement = <T>(array: T[], element: T, index: number): T[] => [...array.slice(0, index), element, ...array.slice(index)];

export default insertElement;
